import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as S from 'src/modules/Opportunities/pages/Explore/Components/SearchSection/SearchButton.sc';

interface Props {
  onClose?: () => void;
  onSearchClick: () => void;
  isLocationError: boolean;
  isMobile?: boolean;
}

export const SearchButton: React.FC<React.PropsWithChildren<Props>> = ({
  isLocationError,
  onSearchClick,
}) => {
  return (
    <S.SearchButton
      disabled={isLocationError}
      onClick={onSearchClick}
      aria-label="Search button"
    >
      <FormattedMessage
        id="job_explore_page.search_button"
        defaultMessage="Search"
      />
    </S.SearchButton>
  );
};
